import type { CSSProperties, ReactNode, TransitionEvent } from 'react'

import { cn } from '@/lib/utils'
import { useAppContext } from '@/app/shell/app-context'

export function ProductLayout({
  sidebar,
  header,
  children,
}: {
  sidebar?: ReactNode
  header?: ReactNode
  children: ReactNode
}) {
  const { sidebarCollapsed, sidebarWidth } = useAppContext()

  return (
    <div
      data-product-layout
      className="@container bg-sidebar h-full min-h-0 flex-1 overflow-hidden"
      style={{ '--product-sidebar-width': `${sidebarWidth}px` } as CSSProperties}
    >
      <div
        className={cn(
          'grid h-full min-h-0 overflow-hidden [.product-sidebar-snapping_&]:transition-[grid-template-columns] [.product-sidebar-snapping_&]:duration-200 [.product-sidebar-snapping_&]:ease-drawer',
          sidebar ? 'grid-cols-[3rem_minmax(0,1fr)]' : 'grid-cols-1',
          sidebar &&
            !sidebarCollapsed &&
            '@min-[48rem]:grid-cols-[var(--product-sidebar-width)_minmax(0,1fr)]',
        )}
        onTransitionEnd={finishSidebarSnap}
      >
        {sidebar}
        <div
          data-product-surface
          className="bg-background mr-2 mb-2 flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl dark:border-[3px] dark:border-sidebar-border"
        >
          {header}
          <div data-product-content className="min-h-0 min-w-0 flex-1 overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

function finishSidebarSnap(event: TransitionEvent<HTMLDivElement>) {
  if (
    event.currentTarget === event.target &&
    event.propertyName === 'grid-template-columns'
  ) {
    document.documentElement.classList.remove('product-sidebar-snapping')
  }
}
